import { Box, Stack, Typography, TextField, Button, Link } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useUserAuth } from '../context/auth_context';
import FirebaseAuth from '../firebase/auth';
import { showToast } from '../utils/toast';

export default function ForgetPassword() {
  const navigate = useNavigate();

  const { user } = useUserAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    let values = {};
    Array.from(e.target).forEach(({ name, value }) => {
      if (name) {
        values[name] = value;
      }
    });

    if (!values.email) {
      return showToast({
        type: 'error',
        message: 'Please enter your email.'
      });
    }

    try {
      await FirebaseAuth.passwordReset(values.email);
    //   navigate('/login');
      showToast({
        type: 'success',
        message: 'Password reset email has been sent!'
      });
    } catch (error) {
      if ('message' in error) {
        showToast({
          type: 'error',
          message: error.message.replace('Firebase: ', '')
        });
      } else {
        showToast({ type: 'error', message: error });
      }
    }
  }

  if (user === 'loading') {
    return <div></div>;
  }
  if (user?.uid) {
    return <Navigate to="/contents" />;
  }

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <Box width="100%" height="100vh" display="flex" alignItems="center" justifyContent="center">
        <Stack maxWidth="400px" width="100%" gap={3} alignItems="center" p="15px">
          <Typography fontWeight={400} variant="h3">
            Reset Password
          </Typography>
          <TextField variant="outlined" fullWidth label="Email" name='email' id='email' />
          <Button type='submit' size="large" fullWidth variant="contained">
            Reset Now
          </Button>
          <Link href="/">
            <Typography variant="body2">Login Now!</Typography>
          </Link>
          <Box sx={{ height: '10vh' }} />
        </Stack>
      </Box>
    </Box>
  );
}
